import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportAgent extends Schema {
    @type("string")
    @defaultValue("")
    personId: string;

    @type("boolean")
    @defaultValue(false)
    inputLocked: boolean;
    @type("boolean")
    @defaultValue(false)
    entering: boolean;
    @type("number")
    @defaultValue(0)
    color: number;
    @type("number")
    @defaultValue(-1)
    intent: number;
    @type("number")
    @defaultValue(-1)
    pad: number;
    @type("number")
    @defaultValue(0)
    dwell: number;
    @type("number")
    @defaultValue(0)
    worked: number;
    @type("number")
    @defaultValue(0)
    walked: number;
    @type("number")
    @defaultValue(-1)
    lastCommandFrame: number;
    @type("number")
    @defaultValue(-100)
    lastPurchaseFrame: number;
    @type("string")
    @defaultValue("")
    feedback: string;
    @type("number")
    @defaultValue(0)
    feedbackUntil: number;
    @type("number")
    @defaultValue(-1)
    building: number;
    @type("number")
    @defaultValue(-1)
    completedPad: number;
    @type("string")
    @defaultValue("")
    upgradeTicket: string;
    @type("number")
    @defaultValue(0)
    radioCooldown: number;
    @type("number")
    @defaultValue(0)
    ticketCredit: number;
    @type("string")
    @defaultValue("")
    ticketFacility: string;
    @type("number")
    @defaultValue(-1)
    ticketStage: number;
    @type("string")
    @defaultValue("")
    ticketChoice: string;
    @type("number")
    @defaultValue(0)
    ticketCost: number;
}
